export default __webpack_public_path__ + "static/media/96.fffc1968.png";